<a class="result mls-result" tabindex="0" role="menuitem" (click)="selectResult.emit(result)" (keydown.enter)="selectResult.emit(result)" (blur)="onBlur.emit()" [attr.data-value]="listing">
  <div class="left">
    <img [src]="listing.imageUrls?.length > 0 && listing.imageUrls[0] ? listing.imageUrls[0] : listing.placeHolderImage" class="listing-image" alt="listing image" />
    <div class="courtesy">
      <p>{{listing | courtesyMessage}}</p>
    </div>
  </div>
  <div class="right">
    <h5 class="price">
      <img src="{{(listing.isFavourite ? '/assets/icons/heart/heart_icon_red.png' : '/assets/icons/heart/heart_icon.png') | staticp}}" width="24px" height="22px"
      (click)="onFavouriteClick($event)" (keydown.enter)="onFavouriteClick($event)" (blur)="onBlur.emit()" tabindex="0"/> {{priceOrPricePerSqFt}}
    </h5>
    <span class="address">{{listing.address}}</span>
    <div class="details">
      <span>
        <b>{{listing.totalBeds ? (listing.totalBeds | number:'1.0-2') : ('na' | translate)}}</b>
        <img src="{{'/assets/icons/listing-details/Bed_icon@1x.svg' | staticp}}" height="14" width="23" alt="beds" />
      </span>
      <span>
        <b>{{listing.totalBaths ? (listing.totalBaths | number:'1.0-2') : ('na' | translate)}}</b>
        <img src="{{'/assets/icons/listing-details/Bath_icon@1x.svg' | staticp}}" height="14" width="23" alt="baths" />
      </span>
      <span>
        <b>
          {{listing.sqFt ? listing.sqFt : ('na' | translate)}}
          <span class="dark-text">SQFT</span>
        </b>
      </span>
    </div>
    <span class="date">Listed {{listing.listingDate | date }}</span>
  </div>
</a>
